import type { IRequestOpts, IResultstash } from "@mne-core/api";
import { QueryController, createCsrfToken, createPutRequestOpts, createUrl, fetchJsonQuery } from "@mne-core/api";

export interface IChangePasswordWithOldPassword {
  oldPassword: string;
  newPassword: string;
}

export interface IChangePasswordWithAuthorization {
  authorization: string;
  newPassword: string;
}

export type TChangePasswordCriteria = IChangePasswordWithOldPassword | IChangePasswordWithAuthorization;

export interface IUpdateUserPasswordOpts extends RequestInit {
  apiUrl: string;
  apikey?: string;
  sessionKey?: string;
  ctrl?: QueryController;
}

export interface IUpdateUserPasswordResponse {
  // Returned in case of response.code === 200
  description?: string;
  // Returned in case of response.code === 412
  message?: string;
  // Returned in case of response.code === 412
  reason?: string;
}

export const createRequest = ({ ...restCriteria }: TChangePasswordCriteria, opts: IRequestOpts): Request => {
  const { apiUrl, sessionKey, ...restOpts } = opts;
  const uri = createUrl(apiUrl, ["authentication", "v1", "password"]).toString();
  return new Request(
    uri,
    createPutRequestOpts(JSON.stringify(restCriteria), { ...restOpts, csrfToken: createCsrfToken(sessionKey, uri) }),
  );
};

async function updateUserPassword(body: TChangePasswordCriteria, opts: IRequestOpts) {
  return await fetchJsonQuery<IResultstash<IUpdateUserPasswordResponse>>(createRequest(body, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default updateUserPassword;
